import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { Condition } from 'components/Condition'
import { connectApi } from 'libs/connectApi'
import ZendeskIntegrationSettings from 'containers/Admin/Surveys/ZendeskIntegrationSettings'
import { HelpdeskIntegrationProvider, HelpdeskIntegrationConsumer } from './context'

class UpdatePrimaryIntegrationHandler extends React.Component {
  static propTypes = {
    updatePrimaryIntegration: PropTypes.func,
    helpdeskIntegrationContext: PropTypes.object,
  }

  componentDidMount() {
    this.props.helpdeskIntegrationContext.setContext({
      updatePrimaryIntegration: this.props.updatePrimaryIntegration,
    })
  }

  render() {
    return null
  }
}

export class HelpdeskIntegrationContainer extends React.Component {
  static propTypes = {
    survey: PropTypes.object,
  }

  updateSurveyTypeToPrimaryIntegration = () => {
    const data = { type: this.props.selectedIntegration }
    this.props.survey.callApi({ data })
  }

  render() {
    return (
      <HelpdeskIntegrationProvider>
        <HelpdeskIntegrationConsumer>
          {(helpdeskIntegrationContext) => (
            <UpdatePrimaryIntegrationHandler
              updatePrimaryIntegration={this.updateSurveyTypeToPrimaryIntegration}
              helpdeskIntegrationContext={helpdeskIntegrationContext}
            />
          )}
        </HelpdeskIntegrationConsumer>
        <Condition.True condition={this.props.selectedIntegration === 'zendesk'}>
          <ZendeskIntegrationSettings />
        </Condition.True>
      </HelpdeskIntegrationProvider>
    )
  }
}

HelpdeskIntegrationContainer.propTypes = {
  selectedIntegration: PropTypes.string.isRequired,
}

export const HelpdeskIntegration = R.compose(
  withRouter,
  connectApi({
    name: 'survey',
    url: ({ match }) => `/account/survey/${match.params.surveyId}/`,
    method: 'patch',
    skip: true,
  })
)(HelpdeskIntegrationContainer)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/HelpdeskIntegration/index.js